import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { TourFloatingButton } from './tours/TourFloatingButton';
import { SmartChatWidget } from './SmartChat/SmartChatWidget';
import { useTour } from '@/context/TourContext';
import styles from '@/styles/floating-buttons.module.css';
import '@/styles/animated-floating-button.css';

const HIDDEN_KEY = 'floating-buttons-hidden';

export const FloatingButtonsContainer: React.FC = () => {
  const location = useLocation();
  const { pageTours, loading: tourLoading } = useTour();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(HIDDEN_KEY) === 'true');

  const shouldShowTour =
    location.pathname !== '/' &&
    !tourLoading &&
    pageTours.length > 0;

  const shouldShowSmartChat =
    location.pathname !== '/' &&
    location.pathname !== '/chat' &&
    !location.pathname.startsWith('/chat/') &&
    !location.pathname.startsWith('/documentos');

  if (hidden || (!shouldShowTour && !shouldShowSmartChat)) {
    return null;
  }

  const handleClose = () => {
    setHidden(true);
    sessionStorage.setItem(HIDDEN_KEY, 'true');
  };

  const isChat = location.pathname === '/chat-juridico';

  return (
    <div className={isChat ? styles.containerTop : styles.container}>
      {shouldShowTour && <TourFloatingButton />}
      {shouldShowSmartChat && <SmartChatWidget />}
      <button
        className={styles.closeBtn}
        onClick={handleClose}
        aria-label="Fechar botões flutuantes"
      >
        <X className="w-3 h-3" />
      </button>
    </div>
  );
};
